import chroma, {Color} from 'chroma-js';
import {log} from 'common/log'

const BLACK = '#000000'
const WHITE = '#FFFFFF'

/**
 * returns the color, that has higher contrast
 */
export function blackOrWhite(color: string | Color | undefined | null) {
	if (!color) return BLACK
	let x: Color;
	if (typeof color === 'string') {
		try {
			x = chroma(color)
		} catch (e) {
			log.error('blackOrWhite error parsing (fallback to black)', e)
			return BLACK
		}
	} else {
		x = color;
	}
	if (x.luminance() <= 0.5) {
		return WHITE
	} else {
		return BLACK
	}
}